<template>
  <QS-login
    :loading="loading"
    :count-number="countNumber"
    :passwordLength="6"
    :system-name="SystemName"
    :loginWithPassword="loginWithPassword"
    @handleSendMsg="handleSendMsg"
    @handleLogin="handleLogin"/>
</template>

<script>
import request from '@/utils/request'
import { SystemName, interfacePrefix } from '@/config'
import { debounce } from '@/utils'
import md5 from 'blueimp-md5'
import { getCloudConfig } from '@/api/login'

let tid = null

export default {
  name: 'Login',
  data() {
    return {
      SystemName,
      countNumber: 0,
      loginForm: {
        username: '',
        password: '',
        captcha: '',
      },
      loading: false,
      redirect: '',
      loginWithPassword: false, // 登录是否需要密码
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true,
    },
  },
  methods: {
    handleSendMsg(val) {
      this.loginForm = val
      const { username, password } = val
      let postData = {
        username: this.loginForm.username.trim(),
      }
      let flag = false
      if (this.loginWithPassword) {
        postData = {
          ...postData,
          password: md5(this.loginForm.password.trim()),
        }
        flag = username && password
      } else {
        flag = !!username
      }
      if (flag) {
        if (tid) {
          clearInterval(tid)
        }
        this.countNumber = 60
        request({
          url: `${interfacePrefix}/user/token/sendSms`,
          method: 'post',
          data: postData,
        }).then(() => {
          tid = setInterval(() => {
            if (this.countNumber <= 0 && tid) {
              clearInterval(tid)
            }
            this.countNumber--
          }, 1000)
        }).catch(() => {
          if (tid) {
            clearInterval(tid)
          }
          this.countNumber = 0
        })
      }
    },
    handleLogin(val) {
      this.loginForm = val
      const { username, password, captcha } = val
      let flag = false
      if (this.loginWithPassword) {
        flag = username && password && captcha
      } else {
        flag = username && captcha
      }
      if (flag) {
        debounce(this.requestLogin(), 500)
      }
    },
    requestLogin() {
      this.loading = true
      this.$store.dispatch('Login', this.loginForm).then(() => {
        this.loading = false
        // 登录成功后重新加载资源，带上租户信息，用于Nginx判断是否根据配置走灰度发布策略
        window.location.reload(true)
        this.$_showMessageAlert() // 登录成功时，显示右下角弹窗
        this.$_showMessageMustRead() // 登录成功时，显示中间弹窗
      }).catch(() => {
        this.loading = false
        // this.$message.error(err.msg)
      })
    },
    getLoginCloudConfig() {
      getCloudConfig({
        configKey: 'loginConfig',
      }).then(({ data }) => {
        this.loginWithPassword = data.loginWithPassword
      })
    },
  },
  created() {
    this.getLoginCloudConfig()
  },
}
</script>

<style scoped>
.login-container{
  background: #212f40 url('~@/assets/img/bg_login_chewu.png') no-repeat;
  background-size: cover;
}
</style>
